import React from 'react'
import Dialog from 'material-ui/Dialog'
import { useEffect, useState } from 'react'

export const ModalSettingMenuPremium = (props) => {
	const [isShow, setShow] = useState(false)

	useEffect(() => {
		setShow(props.isShow)
	}, [props.isShow])

	const closeDialog = () => setShow(true)

	const onCancel = () => {
		closeDialog()
		props.resetToggle()
	}
	const titleStyle = {
		margin: '0 69px 25px 70px',	
		fontFamily: 'HiraKakuPro-W6',
		fontSize: '18px',
		fontWeight: '700',
		fontStyle: 'normal',
		lineHeight: 1.17,
		letterSpacing: 'normal',
		textAlign: 'center',
		color: '#11ad9d',
	  };
	const pStyle = {
		margin: '25px 0',	
		fontFamily: 'HiraKakuPro-W3',
		fontSize: '14px',
		fontWeight: 'normal',
		fontStyle: 'normal',
		lineHeight: 1.43,
		letterSpacing: 'normal',
		color: '#212121',
	}
	const textStyle = {
		color: '#ec407a',
		textDecoration: 'underline'
	}
  
	return (
		


		<div>
			<Dialog
				modal={false}
				open={isShow}
				bodyClassName="modal-missing__profile setting-popup-overflow"
				contentClassName="modal-menu-premium-paper setting-popup-template"
			>
				<div className="modal-missing__profile-content" id="content-appeal__message">
					<h3 style={titleStyle}>プレミアムメニューとは</h3>
					<p style={pStyle}>
						「祈願・祈祷」「縁結び」「送念」 「ヒーリング」など、占い師それぞれが専門性を活かしたメニューを提供することができます。<br></br>
						ユーザー様はポイントを消費し申込みをすることができます。
					</p>
					<p style={pStyle}>詳しくは<a style={textStyle} href='https://fortune.stella-app.com/home/staffblog/detail/12250'>こちら</a>をご覧ください</p>
				</div>
				<div className="modal-appeal__message-btn">
					<input
						type="button"
						value="OK"
						className="modal-appeal__message-btn-cancel"
						onClick={onCancel}
					/>
				</div>
			</Dialog>
		</div>
	)
}
